var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"[ c-flyout__footer ] [ u-hide@from-tablet ]"},[_c('button',{staticClass:"[ c-btn ] [ c-flyout__footer-btn c-flyout__footer-btn--full ]",on:{"click":_vm.applyFilter}},[_c('span',[_vm._v(_vm._s(_vm._f("trans")('Confirm')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }